import { render, staticRenderFns } from "./CreateOrUpdatePurchaseReuqestModel.vue?vue&type=template&id=68b24ccf&scoped=true"
import script from "./CreateOrUpdatePurchaseReuqestModel.vue?vue&type=script&lang=js"
export * from "./CreateOrUpdatePurchaseReuqestModel.vue?vue&type=script&lang=js"
import style0 from "./CreateOrUpdatePurchaseReuqestModel.vue?vue&type=style&index=0&id=68b24ccf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b24ccf",
  null
  
)

export default component.exports